import { useGLTF } from '@react-three/drei';

export function LamellaTexturedBeam(props) {
  const { nodes } = useGLTF('/WoodOutlinedColored.glb');
  const { nodes: lamellaNodes, materials: lamellaMaterials } = useGLTF('/les.glb');

  const lamellaMaterial = lamellaNodes?.lamela?.material || lamellaMaterials?.lamela;

  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cube.geometry} position={props.position} material={props.material || lamellaMaterial} scale={props.scale} rotation={props.rotation} />
    </group>
  );
}

useGLTF.preload('/WoodOutlinedColored.glb');
useGLTF.preload('/les.glb');
